import script from "./BookingPreviewOnly.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingPreviewOnly.vue?vue&type=script&setup=true&lang=ts"

import "./BookingPreviewOnly.vue?vue&type=style&index=0&id=89f5a5d8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89f5a5d8"]])

export default __exports__